declare var swal: any;
import { Component, Input, OnInit, ViewChild} from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SaveCounsellingActivityRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanController, CounsellingPlanRequest, CounsellingActivityController, CounsellingActivityRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, SaveCounsellingPlanRequest } from '../../../../../.././../src/app/ncs/models/actor/actor';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbActivityMonitoringModal } from './activitymonitoringmodal/activitymonitoring.modal';
import { timeInterval } from 'rxjs/operators';
import { NgbViewCounsellingPlanModal } from '../counsellingregistry/modal/viewcounsellingplan.modal';
//import { NgbCounsellingRegistryModal } from './modal/counsellingregistry.modal';
@Component({
  selector: 'activitymonitoring',
  templateUrl: './activitymonitoring.component.html',
  styleUrls: ['./activitymonitoring.component.css']
})
export class ActivityMonitoringComponent implements OnInit {
  @Input() ActorCode: any;
  @Input() FormattedCode: string;
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
  ScheduleDate: NgbDateStruct;
  //public ActorCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public isRequesting: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;
  //@ViewChild('f') IdentitiesForm: NgForm;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  CurrentSaveCounsellingActivityRequest: SaveCounsellingActivityRequest;
  CurrentEditCounsellingActivityRequest: SaveCounsellingActivityRequest;
  CurrentEditCounsellingPlanRequest: SaveCounsellingPlanRequest;
  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.LoadPatientCounsellingPlansIfAny();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentCounsellingPlanController: CounsellingPlanController[];
  CurrentCounsellingPlanRequest: CounsellingPlanRequest;
  LoadPatientCounsellingPlansIfAny() {
    this.LoadCounselling();
  }
  LoadCounselling() {

    this.CurrentCounsellingPlanRequest = new CounsellingPlanRequest();
      this.CurrentCounsellingPlanRequest.ActorCode = this.ActorCode.toString();
      this.CurrentCounsellingPlanRequest.BranchCode = AppData.Instance().SelectedBranchCode;

    //alert(this.ActorCode);
    this.CurrentCounsellingPlanRequest.ConditionalOperator = 20;
    this.CurrentCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCounsellingPlanController();
  }
  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetCounsellingPlanController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetCounsellingPlanController(this.CurrentCounsellingPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCounsellingPlanController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();
          if (this.CurrentCounsellingPlanController.length > 0) {
            this.Selectedplan = this.CurrentCounsellingPlanController[0];
            this.LoadActivity();
          //  this.ShowPalnDetails(this.CurrentCounsellingPlanController[0]);
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService,
    private loginservice: LoginService) { }
  ngOnInit() {
    //this.FormattedCode = this.route.snapshot.paramMap.get('FormattedCode');
    //this.ActorCode = this.route.snapshot.paramMap.get('ActorCode');
    this.CurrentEditCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    this.CurrentEditCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditCounsellingActivityRequest = new SaveCounsellingActivityRequest();
    this.CurrentEditCounsellingActivityRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveCounsellingActivityRequest = new SaveCounsellingActivityRequest();
    this.CurrentSaveCounsellingActivityRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadPatients();
    //this.GetPatientInfoByFormattedCodeController();
  }
  
 
  clearData() {
    this.ScheduleDate = null;
    this.CurrentSaveCounsellingActivityRequest.ActivityTime = null;
    this.CurrentSaveCounsellingActivityRequest.FollowupMode = null;
    this.CurrentSaveCounsellingActivityRequest.Remarks = null;
  }
  

  

  
  onSubmit() {
    // alert("On Submit");
    this.CurrentSaveCounsellingActivityRequest.ActivityDate = new Date(this.parserFormatter.format(this.ScheduleDate));
    this.CurrentSaveCounsellingActivityRequest.ActualActivityDate = null;
    this.CurrentSaveCounsellingActivityRequest.ActualActivityTime = null;
    this.CurrentSaveCounsellingActivityRequest.ActivityStatus = "";
    this.CurrentSaveCounsellingActivityRequest.Assignedto = "";
    this.CurrentSaveCounsellingActivityRequest.AssignedToName = "";
    this.CurrentSaveCounsellingActivityRequest.CounsellingActivityCode = 0;
    this.CurrentSaveCounsellingActivityRequest.CreatedTimeStamp = "";
    this.CurrentSaveCounsellingActivityRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;
    this.CurrentSaveCounsellingActivityRequest.RecordStatus = "";
    this.CurrentSaveCounsellingActivityRequest.ActorCode = this.ActorCode;
    this.CurrentSaveCounsellingActivityRequest.Followupstatus = "Scheduled";
    this.CurrentSaveCounsellingActivityRequest.PlanCode = this.Selectedplan.CounsellingPlanCode;
    this.CurrentSaveCounsellingActivityRequest.ConditionalOperator = 10;
    
     this.actorservice.SaveCounsellingActivity(this.CurrentSaveCounsellingActivityRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
           
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.ShowList = true;
            this.clearData();
            this.LoadActivity();


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  Selectedplan: CounsellingPlanController;
  ShowPalnDetails(objCategory: any) {
    var plan: CounsellingPlanController = objCategory;
    if (plan != null) {
      this.Selectedplan = plan;
      this.LoadActivity();
    }
    else {

    }
  }
  CurrentCounsellingActivitiesByTimeController: CounsellingActivitiesByTimeController;
  CurrentCounsellingActivitiesByTimeRequest: CounsellingActivitiesByTimeRequest;
  LoadActivity() {
    this.CurrentCounsellingActivitiesByTimeRequest = new CounsellingActivitiesByTimeRequest();
    this.CurrentCounsellingActivitiesByTimeRequest.PlanCode = this.Selectedplan.CounsellingPlanCode;
    this.CurrentCounsellingActivitiesByTimeRequest.ActorCode = this.ActorCode;
      this.CurrentCounsellingActivitiesByTimeRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentCounsellingActivitiesByTimeRequest.ConditionalOperator = 10;
    this.CurrentCounsellingActivitiesByTimeRequest.FromDate = new Date();
    this.CurrentCounsellingActivitiesByTimeRequest.ToDate = new Date();
    //this.CurrentCounsellingActivitiesByTimeRequest.IsToday = true;
    //this.CurrentCounsellingActivitiesByTimeRequest.IsDuration = false;
    this.CurrentCounsellingActivitiesByTimeRequest.SearchText = "";
    this.CurrentCounsellingActivitiesByTimeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCounsellingActivitiesByTimeController();
  }
  GetCounsellingActivitiesByTimeController() {
    this.StartRefreshing();


    this.actorservice.GetCounsellingActivitiesByTimeController(this.CurrentCounsellingActivitiesByTimeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  
  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }
  gotoviewprofile() {
    //alert(this.gotoviewprofile);
    this.router.navigate(['testnurse/profileview']);
  }
//AddPlan(){
//  const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
//    {
//      centered: true

//    })
//}
  edit(l: CounsellingActivitiesByTimeController) {

    this.CurrentEditCounsellingActivityRequest.ActivityDate = l.ActivityDate;
    this.CurrentEditCounsellingActivityRequest.ActivityTime = l.ActivityTime;
    this.CurrentEditCounsellingActivityRequest.FollowupMode = l.FollowupMode;
    this.CurrentEditCounsellingActivityRequest.Followupstatus = l.FollowupStatus;
    this.CurrentEditCounsellingActivityRequest.Remarks = l.Remarks;
    this.CurrentEditCounsellingActivityRequest.PlanCode = l.PlanCode;
    this.CurrentEditCounsellingActivityRequest.ActualActivityDate = l.ActualActivityDate;
    this.CurrentEditCounsellingActivityRequest.ActualActivityTime = l.ActualActivityTime;
    this.CurrentEditCounsellingActivityRequest.ActorCode = l.ActorCode;
    this.CurrentEditCounsellingActivityRequest.CounsellingActivityCode = l.CounsellingActivityCode;
    this.CurrentEditCounsellingActivityRequest.CreatedUser = l.CreatedUser;
    this.CurrentEditCounsellingActivityRequest.AssignedToName = l.AssignedToName;
    const modalRef = this.modalService.open(NgbActivityMonitoringModal,
    {
      centered: true,
      backdrop: 'static',
      keyboard: false
      })
    modalRef.componentInstance.CurrentEditCounsellingActivityRequest = this.CurrentEditCounsellingActivityRequest;
    modalRef.componentInstance.ADate = l.ActivityDate;
    modalRef.componentInstance.Time = l.ActivityTime;
    //modalRef.componentInstance.ActivityTime = l.ActivityTime;
    //modalRef.componentInstance.ADate = l.ActivityDate;
    //modalRef.componentInstance.Time = l.ActivityTime;
    modalRef.componentInstance.Code = l.PlanCode;
    modalRef.componentInstance.Name = l.DisplayName;
    modalRef.componentInstance.CreatedUserName = l.CreatedUser;
    modalRef.componentInstance.AssignedToName = l.AssignedToName;
    modalRef.result.then(x => { this.GetCounsellingActivitiesByTimeController() })
    
  }

  Viewplan() {
    this.CurrentEditCounsellingPlanRequest.Concerns = this.Selectedplan.Concerns;
    this.CurrentEditCounsellingPlanRequest.ActorCode = this.Selectedplan.ActorCode.toString();
    this.CurrentEditCounsellingPlanRequest.CounsellingDoctor = this.Selectedplan.CounsellingDoctor;
    this.CurrentEditCounsellingPlanRequest.CounsellingPlanCode = this.Selectedplan.CounsellingPlanCode;
    this.CurrentEditCounsellingPlanRequest.FinancialStatus = this.Selectedplan.FinancialStatus;
    this.CurrentEditCounsellingPlanRequest.PackageCost = this.Selectedplan.PackageCost;
    this.CurrentEditCounsellingPlanRequest.PlanStatus = this.Selectedplan.PlanStatus;
    this.CurrentEditCounsellingPlanRequest.Potential = this.Selectedplan.Potential;
    this.CurrentEditCounsellingPlanRequest.RecommendedPackage = this.Selectedplan.RecommendedPackage;
    this.CurrentEditCounsellingPlanRequest.SelectEmi = this.Selectedplan.SelectEmi;
    this.CurrentEditCounsellingPlanRequest.TreatmentPlan = this.Selectedplan.TreatmentPlan;
    this.CurrentEditCounsellingPlanRequest.VisitCode = this.Selectedplan.VisitCode.toString();
    this.CurrentEditCounsellingPlanRequest.EndDate = this.Selectedplan.EndDate;
    this.CurrentEditCounsellingPlanRequest.StartDate = this.Selectedplan.StartDate;
    const modalRef = this.modalService.open(NgbViewCounsellingPlanModal,
      {
        centered: true,
        size: "lg"
      })
    modalRef.componentInstance.CurrentEditCounsellingPlanRequest = this.CurrentEditCounsellingPlanRequest;
    modalRef.componentInstance.FormattedCode = this.Selectedplan.FormattedCode;
    modalRef.componentInstance.FacilityName = this.Selectedplan.FacilityShortName;
    modalRef.result.then(x => { this.GetCounsellingPlanController() })
  }


}

